import React from "react";
import { AlertTriangleIcon, ClockIcon, HelpCircleIcon, RefreshCwIcon, TrendingUpIcon, WrenchIcon } from "lucide-react";
import { CTAButton } from "../CTAButton";
import { SectionHeading } from "../SectionHeading";
import { gapLines, situations } from "../../data/landing";
const icons = [HelpCircleIcon, ClockIcon, WrenchIcon, TrendingUpIcon, AlertTriangleIcon, RefreshCwIcon];
export function Situations() {
  return <section className="bg-white px-4 py-16 sm:py-20" data-id="element-254" data-mp="2ji7mkkw2lnid">
      <div className="mx-auto max-w-5xl" data-id="element-255" data-mp="2eil8684ia17z">
        <SectionHeading title="Do any of these situations sound familiar?" lead="If you answer YES to even one, I created this system for you." data-id="element-256" data-mp="2ehjxw5vbdirb" />

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-257" data-mp="25ieykxbxhle3">
          {situations.map((s, i) => {
          const Icon = icons[i];
          return <article key={s.title} className="flex flex-col rounded-2xl bg-brand-50 p-5" data-id="element-258" data-mp="3qaajwxjv88n" data-mpi={i}>
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-700 text-white" data-id="element-259" data-mp="3ofqeku3rk5m">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-260" data-mp="183y4or47rixa" />
                </span>
                <h3 className="mt-4 text-[17px] font-bold leading-snug text-ink" data-id="element-261" data-mp="u4ew5x7hq5kg">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-muted" data-id="element-262" data-mp="u6ron4avjybr">{s.text}</p>
              </article>;
        })}
        </div>

        <div className="mx-auto mt-16 max-w-2xl text-center" data-id="element-263" data-mp="1mu5buaortfio">
          <h3 className="font-serif text-3xl font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-264" data-mp="1quo5896batmz">
            And it <em className="italic text-brand-600" data-id="element-265" data-mp="1d3j2gy7ndl8f">shouldn't</em> have to be this way.
          </h3>
          <p className="mt-4 text-lg text-muted" data-id="element-266" data-mp="1i243v0ymyayg">
            I learned something important while developing this system:{" "}
            <strong className="text-ink" data-id="element-267" data-mp="25qx4vbu478zx">knowing more information isn't always the answer.</strong>
          </p>
          <ul className="mt-6 space-y-2" data-id="element-268" data-mp="2ajgg425bxs1k">
            {gapLines.map(l => <li key={l} className="text-lg font-medium text-muted line-through decoration-bad/60" data-id="element-269" data-mp="2kex7db9zmpwd">
                {l}
              </li>)}
          </ul>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-270" data-mp="2aghbkv00msgj">
            But without a process for turning all that information into a decision, you still end up asking{" "}
            <strong className="text-ink" data-id="element-271" data-mp="25jh5ik361ppf">“Okay… what do I do next?”</strong> That's the gap ECU Decision System™ was designed to fill.
          </p>
          <p className="mt-8 rounded-2xl bg-brand-800 px-5 py-6 font-serif text-2xl font-bold leading-snug text-white sm:text-3xl" data-id="element-272" data-mp="1wot10w5f0c1o">
            A repeatable framework for thinking through an ECU job.
          </p>
          <p className="mt-4 text-sm text-muted" data-id="element-273" data-mp="1mry7ysrwv3us">
            Not a replacement for hands-on training or manufacturer documentation — something different.
          </p>
        </div>

        <CTAButton className="mt-10" label="I want a structured system" data-id="element-274" data-mp="1dpylvm21h9kz" />
      </div>
    </section>;
}